import { create } from 'zustand'
import type { StudentProfile, TutorAnalysisResult, LearningStep } from '../types'

interface AppState {
  // Student
  student: StudentProfile
  setStudent: (s: StudentProfile) => void
  updateCurrentStep: (step: string) => void
  
  // Learning
  steps: LearningStep[]
  setSteps: (steps: LearningStep[]) => void
  currentStepId: string
  setCurrentStep: (id: string) => void
  
  // Tutor
  lastAnalysis: TutorAnalysisResult | null
  setAnalysis: (a: TutorAnalysisResult | null) => void
  
  // UI
  sidebarOpen: boolean
  toggleSidebar: () => void
  activeTab: string
  setActiveTab: (tab: string) => void
  
  // Demo mode
  isDemoMode: boolean
  setDemoMode: (v: boolean) => void
}

export const useAppStore = create<AppState>((set) => ({
  student: {
    id: 'student_001',
    name: '학생',
    current_step: 'LS01',
    completed_steps: [],
    mastered_steps: [],
    misconception_history: [],
    score_history: [],
  },
  setStudent: (s) => set({ student: s }),
  updateCurrentStep: (step) => set((state) => ({
    student: { ...state.student, current_step: step },
    currentStepId: step,
  })),
  
  steps: [],
  setSteps: (steps) => set({ steps }),
  currentStepId: 'LS01',
  setCurrentStep: (id) => set({ currentStepId: id }),
  
  lastAnalysis: null,
  setAnalysis: (a) => set({ lastAnalysis: a }),
  
  sidebarOpen: true,
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  activeTab: 'dashboard',
  setActiveTab: (tab) => set({ activeTab: tab }),
  
  isDemoMode: true,
  setDemoMode: (v) => set({ isDemoMode: v }),
}))
